"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PinFill;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function PinFill(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "pin-fill"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M85.775,13.923c-5.8-5.733-11.541-8.64-17.072-8.64h0A13.243,13.243,0,0,0,59.753,8.5c-4.439,3.92-4.3,9.527-3,13.771-3.049,2.706-8.938,7.424-14.506,11.7a30.827,30.827,0,0,0-7.5-.987c-6.748,0-12.044,2.628-15.315,7.6-6.514,9.9,2.629,22.639,7.7,28.472L8.232,87.949a2.5,2.5,0,1,0,3.536,3.535L30.626,72.626c3.985,3.54,12.858,10.457,21.391,10.457A13.723,13.723,0,0,0,59.7,80.855c8.582-5.646,8.465-16,6.64-22.849,4.277-5.57,8.992-11.454,11.69-14.491a17.356,17.356,0,0,0,5.007.8,11.306,11.306,0,0,0,8.718-3.753c3.535-3.721,6.785-13.73-5.393-26.054Z"
  }))));
}